import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import {
  AuthSendActivationOtpRequestBody,
  AuthSendActivationOtpResponse,
} from "./types";

export class AuthSendActivationOtpAPI extends BaseAPI<
  AuthSendActivationOtpRequestBody,
  AuthSendActivationOtpResponse
> {
  protected route = ApiRoutes.auth.send_activation_otp;
  protected method = RequestMethod.POST;
}
